// Brand context — applies brand class to <body> from data-page-brand attribute
// The brand key is set server-side by Liquid (from metaobject or legacy detection)

(function () {
  'use strict';

  var BRAND_CLASS_PREFIX = 'brand--';

  function getCurrentBrandKey() {
    var body = document.body;
    if (!body) return 'zileej';
    return body.getAttribute('data-page-brand') || 'zileej';
  }

  function applyBrandContext() {
    var body = document.body;
    if (!body) return;

    var key = getCurrentBrandKey();

    // Remove existing brand--* classes
    var classes = Array.prototype.slice.call(body.classList || []);
    classes.forEach(function (c) {
      if (c.indexOf(BRAND_CLASS_PREFIX) === 0) {
        body.classList.remove(c);
      }
    });

    // Apply brand class
    body.classList.add(BRAND_CLASS_PREFIX + key);
    body.setAttribute('data-brand-active', key);
  }

  function init() {
    if (typeof document === 'undefined') return;
    applyBrandContext();
    window.getCurrentBrandKey = window.getCurrentBrandKey || getCurrentBrandKey;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
